import styled from 'styled-components';
import { Input, Tag, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

// 页面容器
export const SearchPageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 24px;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const SearchContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 80px rgba(0,0,0,0.08);
  border: 1px solid #e2e8f0;
  
  @media (max-width: 768px) {
    padding: 24px;
    border-radius: 16px;
  }
`;

// 搜索框容器
export const SearchBoxContainer = styled.div`
  position: relative;
  margin-bottom: 32px;
  width: 100%;
`;

// 自定义搜索框 - 与主页样式一致
export const StyledSearchBox = styled(Input)`
  height: 56px;
  border-radius: 28px !important;
  border: 2px solid #e2e8f0 !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  font-size: 16px;
  padding: 0 24px 0 56px !important;
  box-shadow: 0 8px 32px rgba(0,0,0,0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
  
  &::placeholder {
    color: #94a3b8;
    font-weight: 400;
  }
  
  &:hover {
    border-color: #6366f1 !important;
    box-shadow: 0 12px 40px rgba(99, 102, 241, 0.15);
    transform: translateY(-2px);
  }
  
  &:focus {
    border-color: #6366f1 !important;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1), 0 12px 40px rgba(99, 102, 241, 0.15);
    transform: translateY(-2px);
  }
`;

// 搜索图标
export const SearchIcon = styled(SearchOutlined)`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #6366f1;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s ease-out;
  
  &:hover {
    color: #5855eb;
    transform: translateY(-50%) scale(1.1);
  }
`;

// 标题样式
export const SectionTitle = styled(Typography.Title)`
  &.ant-typography {
    font-size: 18px !important;
    font-weight: 700 !important;
    color: #1a202c !important;
    margin: 32px 0 16px 0 !important;
    letter-spacing: -0.02em !important;
    font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif !important;
    
    &:first-of-type {
      margin-top: 0 !important;
    }
  }
`;

// 标签容器
export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
`;

// 历史搜索标签
export const HistoryTag = styled(Tag)`
  font-size: 14px !important;
  padding: 8px 16px !important;
  border-radius: 20px !important;
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.2s ease-out !important;
  will-change: transform, border-color, color !important;
  
  &:hover {
    border-color: #6366f1 !important;
    color: #6366f1 !important;
    background: #ffffff !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15) !important;
  }
`;

// 热门搜索标签
export const HotTag = styled(Tag)`
  font-size: 14px !important;
  padding: 8px 16px !important;
  border-radius: 20px !important;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease-out !important;
  will-change: transform, box-shadow !important;
  
  &:hover {
    background: linear-gradient(135deg, #5855eb 0%, #7c3aed 100%) !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3) !important;
  }
`;

// 空状态提示
export const EmptyState = styled.div`
  color: #94a3b8;
  font-size: 14px;
  padding: 16px 0;
  text-align: center;
  font-style: italic;
`;

// 清除历史按钮
export const ClearHistoryButton = styled.button`
  background: none;
  border: none;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: all 0.2s ease-out;
  margin-left: auto;
  display: block;
  
  &:hover {
    color: #ef4444;
    background: #fef2f2;
  }
`;

// 标题行容器
export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0 16px 0;
  
  &:first-of-type {
    margin-top: 0;
  }
`;